// TrinityFab — plávajúca ikona Trinity + malé chatové okno (Mirko 12. 9. 2026: „nech neotvára novú kartu,
// nech sa iba otvorí konverzačné okienko s poslednou pamäťou"). Vpravo dole na každej prihlásenej obrazovke.
// Obrázok z /uploads/trinity-icon.svg (alebo .png), inak náhradný trojitý uzol. Okno drží posledné vlákno
// (TrinityChat autoLast) a ostáva v pamäti aj po zavretí. Nič nezapisuje. Ústava 102.2, bez emoji (SVG).
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import { COLORS, todayLocal } from '../theme.js'
// Motor = ANTON (Mirko 12. 9.: „povedal som ti, že to má byť Anton“). Anton beží pod /anton/ (brána → web VM :8310),
// prihlási sa sám zo zdieľaného localStorage kamir_token, frame-ancestors povoľuje kamir.ksbx.sk.
const ANTON_URL = '/anton/'

const ICON_PNG = '/uploads/trinity-icon.png'   // Mirkova ikona (12. 9. 2026), priehľadné pozadie
const ICON_SVG = '/uploads/trinity-icon.svg'
const VER = todayLocal()   // denný cache-buster, aby sa nová ikona ukázala bez mazania cache

function Triquetra({ size = 28 }) {
  const p = 'M50 12 C 80 30, 80 70, 50 88 C 20 70, 20 30, 50 12 Z'
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" stroke="#fff" strokeWidth="9" strokeLinecap="round" aria-hidden="true">
      <path d={p} /><path d={p} transform="rotate(120 50 50)" /><path d={p} transform="rotate(240 50 50)" />
    </svg>
  )
}

function Icon({ stage, setStage, size }) {
  if (stage === 0) return <img src={ICON_PNG + '?v=' + VER} alt="" style={{ width: size, height: size, objectFit: 'contain' }} onError={() => setStage(1)} />
  if (stage === 1) return <img src={ICON_SVG + '?v=' + VER} alt="" style={{ width: size, height: size, objectFit: 'contain' }} onError={() => setStage(2)} />
  return <Triquetra size={size} />
}

export default function TrinityFab() {
    const loc = useLocation()
  const [stage, setStage] = useState(0)     // 0 = svg zo servera, 1 = png zo servera, 2 = náhradný uzol
  const [open, setOpen] = useState(false)
  const [mounted, setMounted] = useState(false)   // okno sa po prvom otvorení už neodmontuje — drží rozpísaný text aj konverzáciu
  if (loc.pathname.startsWith('/trinity')) return null
  const toggle = () => { setMounted(true); setOpen(o => !o) }
  const title = open ? 'Zavrieť okno Trinity' : 'Trinity: asistent Matrixu. Pomôže, poradí, vysvetlí obrazovku. Nič nemení.'
  const custom = stage < 2   // vlastná ikona (oranžová + sivá slučka) potrebuje biele pozadie, náhradný uzol oranžové
  return (
    <>
      {mounted && (
        <div role="dialog" aria-label="Trinity, asistent" data-trinity-panel="1"
          style={{ position: 'fixed', right: 22, bottom: 'calc(86px + env(safe-area-inset-bottom, 0px))', width: 'min(400px, calc(100vw - 32px))', height: 'min(600px, calc(100vh - 130px))',
            display: open ? 'flex' : 'none', flexDirection: 'column', background: '#fff', border: '1px solid ' + COLORS.line, borderRadius: 14,
            boxShadow: '0 12px 32px rgba(0,0,0,.22)', zIndex: 9000, overflow: 'hidden' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px 8px 12px', background: '#0f172a', color: '#fff' }}>
            <span style={{ display: 'inline-flex', width: 22, height: 22, borderRadius: '50%', background: custom ? '#fff' : COLORS.brand, alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}><Icon stage={stage} setStage={setStage} size={custom ? 18 : 14} /></span>
            <span style={{ fontWeight: 800, fontSize: 13 }}>Trinity</span>
            <span style={{ fontSize: 11, color: '#94a3b8', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>asistent, motor Anton · pomôže, nič nemení</span>
            <button type="button" onClick={() => { setOpen(false); window.location.assign(ANTON_URL) }} title="Otvoriť Antona na celú obrazovku (vlákna, zápisník, nastavenia)"
              style={{ border: '1px solid #334155', background: 'transparent', color: '#cbd5e1', borderRadius: 6, padding: '2px 8px', fontSize: 11, cursor: 'pointer' }}>Celá obrazovka</button>
            <button type="button" onClick={() => setOpen(false)} title="Zavrieť (konverzácia ostane uložená)" aria-label="Zavrieť"
              style={{ border: 'none', background: 'transparent', color: '#fff', fontSize: 18, lineHeight: 1, cursor: 'pointer', padding: '0 4px' }}>×</button>
          </div>
          <iframe title="Trinity (Anton)" src={ANTON_URL} style={{ flex: 1, minHeight: 0, width: '100%', border: 'none', background: '#fff' }} allow="clipboard-write" />
        </div>
      )}
      <button type="button" onClick={toggle} title={title} aria-label="Trinity, asistent" aria-expanded={open} data-trinity-fab="1"
        style={{ position: 'fixed', right: 22, bottom: 'calc(22px + env(safe-area-inset-bottom, 0px))', width: 52, height: 52, borderRadius: '50%',
          border: open ? 'none' : (custom ? '2px solid #e2e8f0' : 'none'), background: open ? '#0f172a' : (custom ? '#fff' : COLORS.brand), boxShadow: '0 4px 14px rgba(0,0,0,.28)', cursor: 'pointer', zIndex: 9001,
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0, overflow: 'hidden' }}>
        {open ? <span style={{ color: '#fff', fontSize: 26, lineHeight: 1 }} aria-hidden="true">×</span> : <Icon stage={stage} setStage={setStage} size={custom ? 40 : 34} />}
      </button>
    </>
  )
}
